<template>
      <v-autocomplete
        v-model="locatie"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        background-color="#FFFFFF"
        color="#B4B4B4"
        rounded
        :placeholder=hint
        item-text="name"
        item-value="location"
        no-data-text="Niet gevonden"
        flat
        class="searchbox"
        hide-details
        v-on:change="$emit('set-location', locatie)"
        >

      </v-autocomplete>
</template>

<script>
import Vuetify from 'vuetify';
import axios from 'axios';


export default {
  components: {
  },
  props: ['hint'],
  data() {
    return {
      entries: [],
      isLoading: false,
      locatie: null,
      search: null,
    };
  },

  computed: {
      items () {
        return this.entries;
      },
    },

  watch: {
      search (val) {
        // Items have already been requested
        if (this.isLoading) return
        this.isLoading = true
        // Lazily load input items
        axios.get("https://apisupport.infoplaza.nl/geo/search/v1", {
          "params": {
            "q": val,
            "template": "transit"
          },
          "headers": {
            "apikey": "qnR5EumgwYwMeGPW4rX7JQ78AsXwXA"
          }
        })
        .then(res => {
          var data = [];
          data = data.concat(res.data.transit);
          data = data.concat(res.data.general);
          this.entries = data;
          this.isLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
        });
      },
    },

};

</script>

<style lang="scss" scoped>
$autocomplete-enclosed-input-margin-bottom: 5px;

.searchbox {
  margin: 0;
  padding: 4px 8px;
}

</style>
